export const API_METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  QUERY: "QUERY",
};

export const API_STATUS = {
  OK: "OK",
  ERROR: "ERROR",
  INVALID: "INVALID",
  NOT_FOUND: "NOT_FOUND",
  FORBIDDEN: "FORBIDDEN",
  EXISTED: "EXISTED",
  UNAUTHORIZED: "UNAUTHORIZED",
  REDIRECTED: "REDIRECTED",
};

export const ERROR_MESSAGES: Record<string, string> = {
  SCAM_CAT_NAME_EXISTS: "A category with this name already exists. Try a new name.",
  SCAM_CAT_CODE_EXISTS: "Oops! A category with this code already exists. Try a new code.",
  SCAM_CAT_NOT_FOUND: "Oops! Category not found.",
  SCAM_CAT_IN_USE: "Oops! Category is currently in use and cannot be deleted.",
  ARTICLE_CAT_NAME_EXISTS: "Category already exists. Please choose a different category.",
  "ERR_BUSINESS_OWNER.DOMAIN_ALREADY_USED": "Domain is already in use by another profile",
  ERR_INVALID_FILE: "File type not allowed. Allowed types: .csv, .xlsx",
  ERR_FILE_TOO_LARGE: "File size exceeds 50MB limit",
  ERR_EMPTY_FILE: "File is empty",
  ERR_INVALID_FILE_CONTENT: "Invalid file content",
  ERR_UNSUPPORTED_FORMAT: "Unsupported file format",
  ERR_S3_UPLOAD_FAILED: "Failed to upload file to S3",
  ERR_INTERNAL_ERROR: "Failed to upload file",
};

export const BASE_API_URL = "/api";
export const BASE_AUTH_API_URL = "BASE_AUTH_API_URL";
export const BASE_ORGANIZATION_API_URL = "BASE_ORGANIZATION_API_URL";
export const LOGOUT_URL = "/logout/callback";
export const DEFAULT_LOGIN_URL = "DEFAULT_LOGIN_URL";
